
import { useRef } from "react";
import { useFileManagement, fileCategories } from "./useFileManagement";
import { FileListCard } from "./FileListCard";
import { UploadCard } from "./UploadCard";

export default function FileManagement() {
  // File management functionality
  const {
    files,
    editingFile,
    newFileName,
    newFile,
    setNewFileName,
    setNewFile,
    setEditingFile,
    handleDeleteFile,
    startEditingFile,
    saveFileNameEdit,
    handleNewFileChange,
    handleAddFile,
    getCategoryLabel,
  } = useFileManagement();
  
  const fileInputRef = useRef<HTMLInputElement>(null);
  const videoInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <FileListCard 
        files={files}
        editingFile={editingFile}
        newFileName={newFileName}
        setNewFileName={setNewFileName}
        saveFileNameEdit={saveFileNameEdit}
        setEditingFile={setEditingFile}
        handleDeleteFile={handleDeleteFile}
        startEditingFile={startEditingFile}
        getCategoryLabel={getCategoryLabel}
      />
      
      <UploadCard
        newFile={newFile}
        setNewFile={setNewFile}
        handleNewFileChange={handleNewFileChange}
        handleAddFile={handleAddFile}
        fileInputRef={fileInputRef}
        videoInputRef={videoInputRef}
        fileCategories={fileCategories}
      />
    </div>
  );
}
